import {Button, Typography} from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import Loader from "../../../loader";
import format from "date-fns/format";
import customToolbar from "../../../customToolbar";
import CDRTable from "../CDRTable";
import ExportButton from "../exportButton";
import downloadCDRCSV from "../downloadCDRCSV";
import constants from "../../../../constants";
import useFormData from "../../../../useFormData";
import {enqueueSnackbar, useSnackbar} from "notistack";
import {useNavigate} from "react-router-dom";

export const CurrentCDR = () => {

    let [data, setData] = useState(null);
    let config = useSelector(state => state.session.config);
    let dispatch = useDispatch();
    let [showLoader, setShowLoader] = useState(false);
    let [nodata, setNodata] = useState(false);
    let [total, setTotal] = useState(0);
    let getFormData = useFormData();

    const { enqueueSnackbar } = useSnackbar();

    let navigate = useNavigate();

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 25,
        page: 0,
    });


    async function getData(newModel) {
        setShowLoader(true);

        let offset = newModel.page * newModel.pageSize;

        let formData = getFormData();
        formData.append("action", "PageLimit_CurrentMissedCallCDR");
        formData.append("offset", offset);
        formData.append("limit", newModel.pageSize);

        let url = `${config.reportsURL}`;

        try {
            const response = await axios.post(url, formData, {
                timeout: config.apiTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                        setData(response.data.data);
                        setPaginationModel(newModel);
                        if (offset === 0) { //only for first req
                            setTotal(response.data.total || 0);
                        }
                        setNodata(false);
                    } else {
                        setNodata(true);
                    }
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
            setNodata(true);
        }
    }

    useEffect(() => {
        getData({
            pageSize: 25,
            page: 0,
        });
    }, []);

    function onPaginationModelChange(newModel) {
        getData(newModel)
    }

    async function getDataForExport() {
        setShowLoader(true);

        let formData = getFormData();
        formData.append("action", "CurrentMissedCallCDR");

        let url = `${config.reportsURL}`

        try {
            const response = await axios.post(url, formData, {
                timeout: config.exportTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                        downloadCDRCSV(response.data.data, "Current_CDR_" + format(new Date(), "dd_MM_yyyy_HH_mm"));
                    }
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
        }
    }
    async function requestToDownload(startDate, endDate) {
        setShowLoader(true);

        let formData = getFormData();
        formData.append("action", "requestToDownload");
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);

        let url = `${config.requestToDownloadURL}`

        try {
            const response = await axios.post(url, formData, {
                timeout: config.exportTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    // navigate('/downloadReports');
                    enqueueSnackbar(response.data.message, {
                        variant: 'success',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }
                    })
                }

                if (response.data.status === "FAILURE") {
                    enqueueSnackbar(response.data.message, {
                        variant: 'error',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }
                    })
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
        }
    }

    function handleExportClick() {
        getDataForExport();
        // let today =  format(new Date(), 'yyyy-MM-dd');
        // // let s = today + 'T00:00:00';
        // // let e = today + 'T23:59:59';
        // requestToDownload(today, today);
    }

    return (
        <>
            <Typography variant="body1">Current CDR</Typography>
            <div style={{ marginTop: '5px' }}>
                <ShowTable data={data}
                    onPaginationModelChange={onPaginationModelChange}
                    exportClick={handleExportClick}
                    total={total}
                    model={paginationModel} />
            </div>
            <Loader showLoader={showLoader} />
            {
                nodata ?
                    <div style={{ textAlign: 'center' }}>No Data Found!</div> : null
            }
        </>
    )
}



function ShowTable({ data, onPaginationModelChange, exportClick, total, model }) {
    if (!data) {
        return <></>;
    }

    function exportButtonClick() {
        if (exportClick) {
            exportClick();
        }
    }

    function handlePMC(model) {
        onPaginationModelChange(model)
    }

    return <CDRTable data={data} slot={
        <ExportButton onClick={exportButtonClick} />
    } onPaginationModelChange={handlePMC}
        total={total}
        model={model} />
}

function Table1({ data }) {

    let rows = data;


    let columns = [
        {field: 'Country', headerName: 'Country', sortable: false},
        {field: 'MobileNo', headerName: 'MobileNo', sortable: false},
        {field: 'VMN', headerName: 'VMN', sortable: false},
        {field: 'Trans_id', headerName: 'Transaction ID', width: 250, sortable: false},
        {field: 'DID', headerName: 'DID', width: 250, sortable: false},
        {field: 'MissedCall_Date', headerName: 'MissedCall Date', width: 250, sortable: false},
        {field: 'MissedCall_Time', headerName: 'MissedCall Time', width: 250, sortable: false},
        {field: 'Contestant_name', headerName: 'Contestant Name', width: 250, sortable: false},
        {field: 'status', headerName: 'Status', sortable: false},
    ]

    let CustomToolbar = customToolbar("CDR_CURR" + format(new Date(), "dd_MM_yyyy_HH_mm"));

    return (<>
        <div style={{marginTop: '5px', marginBottom: '5px'}}>
            {/*<b>Showing Current Day Missed Call CDR</b>*/}
        </div>
        <DataGrid rows={rows} columns={columns} getRowId={(r) => r.Trans_id} slots={{
            toolbar: CustomToolbar,
        }}/>
    </>)
}
